import React from "react";
import PropTypes from "prop-types";
import RoleRoute from "./RoleRoute";

function AdminRoute({ ...rest }) {
  return <RoleRoute {...rest} requiredRoles={["orgAdmin"]} />;
}

export default AdminRoute;
